"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Spinner", {
    enumerable: true,
    get: function() {
        return Spinner;
    }
});
var _system = require("@chakra-ui/system");
var _themetools = require("@chakra-ui/theme-tools");
var spin = (0, _system.keyframes)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
var speed = "0.70s";
var Spinner = {
    baseStyle: {
        animation: "".concat(spin, " ").concat(speed, " linear infinite")
    },
    sizes: {
        xs: {
            px: "0.75rem",
            py: "0.75rem"
        },
        s: {
            px: "0.875rem",
            py: "0.875rem"
        }
    },
    variants: {
        accent: {
            borderColor: "accent-default",
            borderLeftColor: (0, _themetools.transparentize)("accent-default", 0.3),
            borderBottomColor: (0, _themetools.transparentize)("accent-default", 0.3)
        },
        primary: {
            borderColor: "primary-default",
            borderLeftColor: (0, _themetools.transparentize)("primary-default", 0.3),
            borderBottomColor: (0, _themetools.transparentize)("primary-default", 0.3)
        }
    },
    defaultProps: {
        size: "s",
        variant: "primary",
        thickness: "0.125rem"
    }
};
